namespace h5_vm {
   export class PowerState {
      static readonly POWERED_ON: string = "poweredOn";
      static readonly POWERED_OFF: string = "poweredOff";
      static readonly SUSPENDED: string = "suspended";
   }
}
